import { z } from 'zod'

// An app the turn could not use. `toolkit` is nullable on purpose: a user with
// nothing connected produces a request that names no app, and that is exactly
// the case worth surfacing. `connect_url` is nullable too — a card that names
// the broken app still beats a reply that just says it cannot help.
export const connectCardSchema = z.object({
  toolkit: z.string().nullable(),
  reason: z.string().optional(),
  connect_url: z.string().nullable().optional(),
  connection_id: z.string().optional(),
})
